module.exports = __webpack_public_path__ + "static/media/003_createcluster.51b20ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/screenshots/googlecloud/003_createcluster.png
// module id = 467
// module chunks = 0